import React from 'react'
import PropTypes from 'prop-types'
import styles from './style/document_link_style.module.scss'
import Typography from '../../foundations/typography/Typography'
import Icon from '../../foundations/icon/Icon'
import Foundation from '../../foundations/Foundation'
import BackHoverImage from '../../basics/back-hover-image/BackHoverImage'
import axios from 'axios'


const downloadFile = (url, docName) => {
    const FileDownload = require('js-file-download')
    axios.get(url, {
            'Content-Type': 'text/plain',
            responseType: 'blob'
        })
        .then(response => {
            FileDownload(response.data, docName)
        })
}

const DocumentLink = ({ children, image, docName, link, gtmLabel, className = '', brand, ...props }) => {
    return (
        <div className={`${styles['document-link']} ${className}`}
             onClick={() => downloadFile(link, docName)}
             gtm-label={gtmLabel}
        >
            <div className={styles['document-link-background']}>
                <BackHoverImage
                    hoverSrc={image}
                />
            </div>
            <Foundation neutral-900>
                <div className={styles['document-link-content']}>
                    <Icon className={`${styles['document-link-logo']}`} img={`logo_${brand}`} contain {...props} />

                    <Typography typeface="title-s-bold" block {...props} className={`${styles['document-link-text']}`}>
                        {children[0]}
                    </Typography>

                    <Typography typeface="title-xxs-medium" block {...props} className={`${styles['document-link-text']}`}>
                        {children[1]}
                    </Typography>

                    <Icon className={`${styles['link-icon']}`} size={32} img="download"/>
                </div>
            </Foundation>
        </div>
    )
};

DocumentLink.propTypes = {
    brand: PropTypes.oneOf(['sensa', 'scalea']).isRequired,
    link: PropTypes.string.isRequired,
    docName: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
}

export default DocumentLink;